// Firebase (project: ahava-alf) — Firestore lead storage + Analytics
import { initializeApp } from "firebase/app";
import { getFirestore, collection, addDoc, serverTimestamp } from "firebase/firestore";
import { getAnalytics, isSupported } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyA106LITJ-XlziQ8Jp1d0aoFbNLEO8pXjg",
  authDomain: "ahava-alf.firebaseapp.com",
  projectId: "ahava-alf",
  storageBucket: "ahava-alf.firebasestorage.app",
  messagingSenderId: "286943392265",
  appId: "1:286943392265:web:396a4dce550912f54dfed8",
  measurementId: "G-779CEZGKFL"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

isSupported().then((yes) => { if (yes) getAnalytics(app); }).catch(() => { });

// Save a lead to Firestore. Never throws — returns the doc id or null.
export async function saveLead(collectionName, data) {
  try {
    const doc = await addDoc(collection(db, collectionName), {
      ...data,
      createdAt: serverTimestamp(),
      page: window.location.pathname + window.location.search,
      userAgent: navigator.userAgent,
    });
    return doc.id;
  } catch (err) {
    console.error("Firestore lead save failed", err);
    return null;
  }
}
